import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const MultipleSelectionIcon = ({ viewBox = '0 0 16 16', ...props }: SvgIconProps) => {
  return (
    <SvgIcon viewBox={viewBox} {...props} sx={{ width: '16px', height: '16px' }}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.5 4H13.5V5.75H8.5V4ZM8.5 11H13.5V12.75H8.5V11ZM6.875 3.125H3.125V6.875H6.875V3.125ZM6.20536 6.20536H3.79464V3.79464H6.20536V6.20536ZM6.875 9.5H3.125V13.25H6.875V9.5ZM6.20536 12.5804H3.79464V10.1696H6.20536V12.5804Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};

export default MultipleSelectionIcon;
